<app-back-button />
<div class="contents">
  <div class="page-header">
    <div class="left-area">
      <span class="title">Solicitações</span>
      <span class="sub-title">Adicione, consulte e edite solicitações</span>
    </div>
    <div class="indicator">
      <div class="icon">
        <img src="icons/certificate-01.svg" alt="User minus Icon" />
      </div>
      <div class="text-bg">
        <span>{{ solicitacoesCount }} Solicitações</span>
      </div>
    </div>
  </div>

  <div class="row">
    <app-search-bar
      [showPrimaryBtn]="false"
      [showFilterBtn]="true"
      (onFilterBtnClick)="showDialog()"
    ></app-search-bar>
  </div>

  <div class="row">
    @if (pagination.data?.length) {
    <app-table
      [pagination]="pagination"
      [columns]="columns"
      [actions]="actions"
      (pageChange)="onPageChange($event)"
      (rowClick)="GotoViewProcess($event)"
    ></app-table>
    } @else {
    <div class="no-data">
      <app-data-void
        titulo="Nehuma solicitação encontrada"
        descricao="Tente novamente mais tarde!"
      ></app-data-void>
    </div>
    }
  </div>
</div>

<p-dialog
  header="Filtros"
  [modal]="true"
  [(visible)]="showFilter"
  [style]="{ width: '40rem' }"
  appendTo="body"
>
  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select
        *ngIf="filter.type === 'dropdown'"
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        [options]="filter.options"
        [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel"
        [optionValue]="filter.optionValue"
        class="w-full"
      >
      </p-select>

      <!-- Se for texto -->
      <input
        *ngIf="filter.type === 'text'"
        pInputText
        [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder"
        class="w-full"
      />

      <!-- Se for Data
      <p-datepicker *ngIf="filter.type === 'date'" [formControlName]="filter.controlName" [minDate]="minDate"
        [maxDate]="maxDate" [placeholder]="filter.placeholder" appendTo="body" class="w-full" dateFormat="dd.mm.yy"
        showIcon iconDisplay="input" /> -->
    </div>
  </form>

  <div class="flex items-center justify-content-between">
    <p-button
      label="Cancelar"
      severity="secondary"
      (click)="showFilter = false"
    />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>

<p-toast></p-toast>
